<script>
</script>

<footer class="footer bg-light">
	<div class="container-fluid d-flex flex-md-row flex-column justify-content-between align-items-md-center gap-1 container-p-x py-3">
		<div>
			<a href="https://themeselection.com" target="_blank" class="footer-link me-4">©2024 sleepwave</a>
		</div>
		<div>
			<a href="https://github.com/themeselection" class="footer-link me-4" target="_blank">
				<i class="bx bxl-github bx-sm"></i>
			</a>
			<a href="https://www.facebook.com/ThemeSelections/" class="footer-link me-4" target="_blank">
				<i class="bx bxl-facebook bx-sm"></i>
			</a>
			<a href="https://twitter.com/Theme_Selection" class="footer-link me-4" target="_blank">
				<i class="bx bxl-twitter bx-sm"></i>
			</a>
			<a href="https://www.instagram.com/themeselection/" class="footer-link" target="_blank">
				<i class="bx bxl-instagram bx-sm"></i>
			</a>
		</div>
	</div>
</footer>
